import clsx from 'clsx';
import type { FC } from 'react';

import { authHeaderWrapper } from './share.css';

const HappenedMark = () => (
  <svg
    className="logo"
    width="1em"
    height="1em"
    viewBox="0 0 192 192"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="hp-auth-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#6366F1" />
        <stop offset="1" stopColor="#4F46E5" />
      </linearGradient>
    </defs>
    <rect width="192" height="192" rx="44" fill="url(#hp-auth-bg)" />
    <rect x="50" y="48" width="22" height="96" rx="6" fill="#FFFFFF" />
    <rect x="120" y="48" width="22" height="96" rx="6" fill="#FFFFFF" />
    <rect x="64" y="85" width="64" height="22" rx="6" fill="#FFFFFF" />
    <circle cx="142" cy="50" r="13" fill="#34D399" stroke="url(#hp-auth-bg)" strokeWidth="5" />
  </svg>
);

export const AuthHeader: FC<{
  title: string;
  subTitle?: string;
  className?: string;
}> = ({ title, subTitle, className }) => {
  return (
    <div className={clsx(authHeaderWrapper, className)}>
      <p>
        <HappenedMark />
        {title}
      </p>
      <p>{subTitle}</p>
    </div>
  );
};
